/* projects/speaker-platform/src/app/pages/seances-upload/seances-upload.component.scss */
.seancesupload__toupload {
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1607843137);
}
.seancesupload__toupload__label {
  font-style: italic;
  color: #818181;
  text-align: center;
  margin-bottom: 16px;
}
.seancesupload__selected {
  font-size: 22px;
  margin-bottom: 32px;
}
.seancesupload .table thead tr td {
  background-color: transparent;
}
/*# sourceMappingURL=seances-upload.component-F7NCBKUP.css.map */
